import { SyncShopifyProductsForTeamResponse } from "@redotech/redo-model/shopify/sync-shopify-products";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const syncShopifyProductsForTeam = {
  name: "syncShopifyProductsForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    response: createEnum(SyncShopifyProductsForTeamResponse),
  }),
};
